let rootElement = document.getElementById("papername-gift");
let ReactApp = null;

window.addEventListener("load", (event) => {
  if (rootElement) {
    import("react")
      .then((react) => {
        (function() {
          /**
           * @namespace
           * @description Global instance of React
           */
          this.React = react;
          import("react-dom")
            .then((reactDOM) => {
              import("./App")
                .then((App) => {
                  /**
                   * @method render
                   * @param {component} Component valid React component
                   * @param {id} id HTML element id to attach component at
                   * @description Method used to attach the main React component to the main custom element selecting it by id.
                   * @memberOf ReactDOM
                   * @instance
                   */
                  removeLoader().then(
                    () =>
                      (ReactApp = reactDOM.render(<App.default />, rootElement))
                  );
                })
                .catch((err) => {
                  console.log(
                    `${window.INITIAL_DATA.TRANSLATIONS.could_not_load} <App /> `,
                    err.message
                  );
                });
            })
            .catch((err) => {
              console.log(
                `${window.INITIAL_DATA.TRANSLATIONS.could_not_load} reactDOM `,
                err.message
              );
            });
        }.apply(window));
      })
      .catch((err) => {
        console.log(
          `${window.INITIAL_DATA.TRANSLATIONS.could_not_load} react `,
          err.message
        );
      });
  }
});

export default ReactApp;

async function removeLoader(): Promise<boolean> {
  document.querySelector(".js-react-app-loader").remove();
  return true;
}
